import React, { useEffect, useState } from "react"
import { useAuthenticationDataContext } from "../../Helpers/AuthenticationDataProvider";
import { useIntlWrapperContext } from "../../Helpers/IntlWrapperProvider";
import useFetchWrapper, { HttpResponse } from "../../Helpers/useFetchWrapper";
import { AdminProfile } from "./AdminProfile.model";

export const useAdminProfile = () => {
  const [profile, setProfile] = useState<AdminProfile>();
  const [editEmail, setEditEmail] = useState(false);
  const [editImage, setEditImage] = useState(false);
  const [editLocation, setEditLocation] = useState(false);
  const [editName, setEditName] = useState(false);
	const [email, setEmail] = useState<string>();
	const [loading, setLoading] = useState(true);
  const [showPasswordPopup, setShowPasswordPopup] = useState(false);
  const { get, put } = useFetchWrapper();
  const { userId } = useAuthenticationDataContext();
  const { i18nCountries } = useIntlWrapperContext();
	const [isInvalidEmail, setIsInvalidEmail] = useState<boolean>(false);

	const {
		setFullName
	} = useAuthenticationDataContext();

  useEffect(() => {
    getProfile();
    getEmail();
  }, []);
	
	useEffect(() => {
		validateEmail();
	}, [email]);
	
	const validateEmail = () => {
		const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
		if (email && reg.test(email)) {
			setIsInvalidEmail(false);
		} else 
			setIsInvalidEmail(true);
	};

  const getProfile = async () => {
		!loading && setLoading(true);
    const response: HttpResponse<AdminProfile> = await get(`/user/profile/${userId}`);
    if (response.parsedBody) {
      const { firstName, imageId, isReachableByText, isReachableByCall, lastName, location, role } = response.parsedBody;
      setProfile({firstName, imageId, isReachableByCall, isReachableByText, lastName, location, role});
			setFullName(firstName, lastName);
		}
		setLoading(false);
  }

  const getEmail = async () => {
    const response: HttpResponse<any> = await get(`/user/settings`);
    if (response.parsedBody) {
      const { email } = response.parsedBody;
      setEmail(email);
    }
  }

  const toggle = (set: React.Dispatch<React.SetStateAction<boolean>>, value: boolean) => {
    set(!value);
  }

  const updateEmail = async () => {
    const response = await put('/user/settings/email', { email });
  }

  const updatePersonalInformation = async () => {
    const response = await put(`/user/profile/${userId}`, profile);
    getProfile();
  }

  return {
    i18nCountries,
    setEmail,
    setProfile,
    state: {
      editEmail,
      editImage,
      editLocation,
      editName,
			email,
			isInvalidEmail,
			loading,
      profile,
      showPasswordPopup
    },
    toggleEmailField: () => {
      toggle(setEditEmail, editEmail);
    },
    toggleImagePopup: () => {
      toggle(setEditImage, editImage);
    },
    toggleLocationField: () => {
      toggle(setEditLocation, editLocation);
    },
    toggleNameField: () => {
      toggle(setEditName, editName);
    },
    togglePasswordPopup: () => {
      toggle(setShowPasswordPopup, showPasswordPopup);
    },
    updateEmail,
    updatePersonalInformation
  }
}